import { redirect } from 'react-router-dom';
import Cookies from 'js-cookie';
export const checkAuth = () => {
  const token = Cookies.get(`token`);

  if (!token) {
    window.location.href = '/authen/login';
    return redirect('/');
  }

  return null;
};
